<template>
  <a-card :bordered="false" :headStyle="{ fontSize: '18px' }">
    <template slot="title">
      <div class="title-box">
        <span class="title">余额对账<span style="margin-left: 30px">*每次最大导出31天数据</span></span>
      </div>
    </template>
    <div class="form-box">
      <a-form-item label="对账周期" v-bind="searchItemLayout" style="width: 800px">
        <a-space style="margin-left: 20px">
          <a-range-picker
            style="width: 400px"
            :show-time="{ format: 'HH:mm' }"
            v-model="selectDate"
            format="YYYY-MM-DD HH:mm"
            :placeholder="['开始时间', '结束时间']"
            :disabled-date="disabledDate"
            allowClear
            @change="handleChange"
          />
          <a-button type="primary" @click="onExportEvent">导 出</a-button>
          <a-button @click="toDownloadTable">查看已生成报表</a-button>
        </a-space>
      </a-form-item>
    </div>
  </a-card>
</template>
<script>
import moment from 'moment'

export default {
  name: 'index',

  data() {
    return {
      searchItemLayout: {
        labelCol: {
          span: 4
        },
        wrapperCol: {
          span: 20
        }
      },
      selectDate: []
    }
  },
  methods: {
    getMoment(dateStr) {
      return moment(dateStr, 'YYYY-MM-DD HH:mm')
    },
    formatMoment(m) {
      return m.format('YYYY-MM-DD HH:mm')
    },
    /**
     * 禁用日期逻辑
     * @param {Moment} current - 日历上当前悬停/点击的日期对象
     */
    disabledDate(current) {
      if (!current) return false

      const startStr = this.selectDate?.[0]
      const endStr = this.selectDate?.[1]

      // 【关键步骤】因为设置了 valueFormat，this.dateRange 里是字符串
      // 必须转为 Moment 对象才能使用 diff 等方法
      const startDate = startStr ? startStr : null
      const endDate = endStr ? endStr : null

      // 场景 1: 已选开始时间，正在选结束时间
      if (startDate && startDate.isValid() && !endDate) {
        // 计算天数差 (忽略具体时间，只看日期跨度)
        // 如果 (当前日期 - 开始日期) > 31，则禁用
        if (current.diff(startDate, 'day') > 31) {
          return true
        }
        // 可选：禁止选择早于开始时间的日期
        if (current.isBefore(startDate, 'day')) {
          return true
        }
      }

      // 场景 2: 已选结束时间，正在选开始时间
      if (endDate && endDate.isValid() && !startDate) {
        // 如果 (结束日期 - 当前日期) > 31，则禁用
        if (endDate.diff(current, 'day') > 31) {
          return true
        }
        // 可选：禁止选择晚于结束时间的日期
        if (current.isAfter(endDate, 'day')) {
          return true
        }
      }

      return false
    },
    /**
     * 二次校验：防止通过代码赋值或特殊操作导致超出范围
     */
    handleChange(dates, dateStrings) {
      this.errorTip = ''
      // dates 是 Moment 对象数组，dateStrings 是字符串数组
      if (dates && dates[0] && dates[1]) {
        const start = dates[0]
        const end = dates[1]
        const diffDays = end.diff(start, 'day')
        if (diffDays > 31) {
          this.errorTip = '错误：选择的时间跨度不能超过 31 天！'
          // 策略：自动清空结束时间，让用户重新选择
          // 注意：直接修改 this.dateRange 可能会触发再次 change，需小心处理
          // 这里我们简单地提示，或者你可以强制重置
          this.$message.warning('时间跨度不能超过 31 天，请重新选择结束时间')
          this.selectDate = [dates[0], undefined]
        }
      }
    },
    toDownloadTable() {
      this.openNewPage('DownloadTable')
    },
    onExportEvent() {
      if (!this.selectDate || this.selectDate.length < 1) {
        this.$message.error('请选择导出的时间范围')
        return false
      }
      const url = '/member/v3/balance/export'
      const params = {
        merchantId: this.$store.getters.userInfo.merchantId,
        startTime: this.formatMoment(this.selectDate[0]),
        endTime: this.formatMoment(this.selectDate[1])
      }
      this.getHttpServices().getMemberAuthService().post(url, params)
        .then(res => {
          this.$message.success('导出请求提交成功')
        })
        .catch(err => {
          if (err && err.msg) {
            this.$message.error(err.msg)
          } else {
            this.$message.error('操作失败，请重试！')
          }
        })
    }

  }
}
</script>

<style scoped lang="less">
.title-box {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .title {
    font-size: 20px;
    font-weight: 500;

    span {
      font-size: 14px;
      font-weight: 400;
    }
  }
}

.form-box {
  width: 100%;
  display: flex;
  align-items: center;
}
</style>